import * as React from 'react';
import { NumericInput, type NumericInputProps } from '@/components/ui/numeric-input';
import { getCurrencySymbol, cn } from '@/lib/utils';

interface CurrencyInputProps extends Omit<NumericInputProps, 'integer' | 'sign'> {
  currencyCode: string;
  integer?: boolean;
  sign?: NumericInputProps['sign'];
}

const CurrencyInput = React.forwardRef<HTMLInputElement, CurrencyInputProps>(
  ({ currencyCode, integer = false, sign = 'positive', className, ...rest }, ref) => {
    const symbol = getCurrencySymbol(currencyCode);

    return (
      <div className="relative flex items-center">
        <span className="pointer-events-none absolute left-2 text-muted-foreground text-sm select-none">
          {symbol}
        </span>
        <NumericInput
          ref={ref}
          integer={integer}
          sign={sign}
          className={cn('pl-6', className)}
          {...rest}
        />
      </div>
    );
  },
);

CurrencyInput.displayName = 'CurrencyInput';

export { CurrencyInput };
export type { CurrencyInputProps };
